import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentViewerService {
  baseURL = environment?.documentViewer;
  urlSafe: SafeResourceUrl;
  constructor(public sanitizer: DomSanitizer) {}

  ngOnInit() {
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlDoc);
  }

  selectDocumentType(type: any,url:string) {
    switch (type) {
      case 'docx':
        url = this.baseURL + url;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
      
        window.open(url, '_blank');
        break;
        case 'doc':
          url = this.baseURL + url;
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
            url
          );        
          window.open(url, '_blank');
          break;
      case 'xlsx':
        url = this.baseURL + url;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
        window.open(url, '_blank');
        break;
        case 'xls':
          url = this.baseURL + url;
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
            url
          );
          window.open(url, '_blank');
          break;  
      case 'pptx':
        url = this.baseURL + url;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
        window.open(url, '_blank');
        break;
      case 'ppt':
        url = this.baseURL + url;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
        window.open(url, '_blank');
        break;
      case 'csv':
        url = this.baseURL + url;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
        window.open(url, '_blank');
        break;
      case 'pdf':
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
        window.open(url, '_blank');
        break;
      case 'jpg':
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
        window.open(url, '_blank');
        break;
      case 'jpeg':
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
        window.open(url, '_blank');
        break;
      case 'png':
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
            url
        );
        window.open(url, '_blank');
        break;
          case 'gif':
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
              url
            );
            window.open(url, '_blank');
            break;
          case 'txt':
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
              url
            );
            window.open(url, '_blank');
            break;
      default:
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          url
        );
    }
  }

  previewDocument(docType: string, data: any): void {
    switch (docType) {
      case 'docx':
      this.selectDocumentType(docType,data?.encodedDownloadLink);
      break;
      case 'doc':
      this.selectDocumentType(docType,data?.encodedDownloadLink);
      break;
      case 'xlsx':
          this.selectDocumentType(docType,data?.encodedDownloadLink);
        break;
      case 'xls':
        this.selectDocumentType(docType,data?.encodedDownloadLink);
      break;  
      case 'pptx':
          this.selectDocumentType(docType,data?.encodedDownloadLink);
        break;
      case 'ppt':
        this.selectDocumentType(docType,data?.encodedDownloadLink);
        break;
      case 'csv':
          this.selectDocumentType(docType,data?.encodedDownloadLink);
        break;
      case 'pdf':
          this.selectDocumentType(docType,data?.downloadLink);
        break;
      case 'jpg':
          this.selectDocumentType(docType,data?.downloadLink);
        break;
      case 'jpeg':
        this.selectDocumentType(docType,data?.downloadLink);
        break;
        case 'png':
          this.selectDocumentType(docType,data?.downloadLink);
        break;
        case 'gif':
          this.selectDocumentType(docType,data?.downloadLink);
        break;
        case 'txt':
          this.selectDocumentType(docType,data?.downloadLink);
        break;
      default:
          this.selectDocumentType(docType,data?.downloadLink);
    }
  }

}
